import constate from 'constate';
import { useEffect, useReducer, useRef } from 'react';
import createReducer from 'helpers/reducers-helper';
import {
  isCreditCardCVC,
  isCreditCardExpireDate,
  isCreditCardPan,
  isEmail,
  isOtpCode,
  isPhoneNumber,
  isPlateNumber,
} from 'helpers/rule-validation';
import { getCpcId } from 'service/local-data-provider';
import repo from 'service/repository';
import assign from 'lodash/assign';
import { useHistory } from 'react-router-dom';
import { CAR_TYPE } from 'model/license-plate';
import { useAppContext, INIT_APP_DONE, UPDATE_USER_INFO, BINDING_IS_SETTED, LICENSE_PLATES_IS_SETTED } from 'use-app';
import appLoader from 'distributor/app-loader';
import amplitude from 'service/amplitude';
import { expireDateFormatter, panFormatter } from 'helpers/credit-card-helper';
import { PATH, isCpcpay, isIknow99, isNpcpay } from 'config';
import { connectMQTT } from 'helpers/connect-mqtt';

export const START_LOADING = 'start_loading';
export const HIDE_LOADING = 'hide_loading';
export const FETCH_OTP_SUCCESS = 'fetch_otp_success';
export const OTP_TIMES_UP = 'otp_times_up';
export const CHANGE_MOBILE = 'change_phone';
export const CHANGE_OTP = 'change_otp';
export const CHANGE_MOBILE_ERROR_MESSAGE = 'change_mobile_error_message';
export const CHANGE_OTP_ERROR_MESSAGE = 'change_otp_error_message';
export const CHANGE_EMAIL = 'change_email';
export const CHANGE_EMAIL_ERROR_MESSAGE = 'change_email_error_message';
export const SET_ON_STREET_PARKING_AUTO_PAY_PASS_DIALOG = 'set_on_street_parking_auto_pay_pass_dialog';
export const SET_RENTAL_PLATE_DIALOG = 'SET_RENTAL_PLATE_DIALOG';
export const CHANGE_PLATE_NUMBER = 'change_plate_number';
export const CHANGE_PLATE_NUMBER_ERROR_MESSAGE = 'change_plate_number_error_message';
export const CHANGE_CAR_TYPE = 'change_car_type';
export const BIND_CARD_FAILED = 'bind_card_failed';
export const CHANGE_CC_NUMBER = 'change_cc_number';
export const CHANGE_CC_NUMBER_ERROR_MESSAGE = 'change_cc_number_error_message';
export const CHANGE_CC_EXPIRE_DATE = 'change_cc_expire_date';
export const CHANGE_CC_EXPIRE_DATE_ERROR_MESSAGE = 'change_cc_expire_date_error_message';
export const CHANGE_CC_CVC = 'change_cc_cvc';
export const CHANGE_CC_CVC_ERROR_MESSAGE = 'change_cc_cvc_error_message';
export const APPEND_PAYMENT_DATA = 'append_payment_data';
export const SHOW_LOADING_COVER = 'show_loading_cover';
//iknow99
export const SET_ACTIVATED_LICENSE_PLATES = 'set_activated_license_plates';
export const SET_ACTIVATE_LICENSE_PLATES_DIALOG = 'SET_ACTIVATE_LICENSE_PLATES_DIALOG';

const useLoginFlow = () => {
  const { state: appState, dispatch: appDispatch, showFailMessage, showSuccessMessage } = useAppContext();
  const { configData, methods } = appLoader;
  const history = useHistory();
  const initState = {
    mobile: '',
    mobileErrorMessage: '',
    otp: '',
    otpErrorMessage: '',
    email: '',
    emailErrorMessage: '',
    onStreetParkingAutoPayPassDialog: false,
    onStreetParkingAutoPay: true,
    showRentalPlateDialog: false,
    plateNumber: '',
    plateNumberErrorMessage: '',
    carType: CAR_TYPE.key,
    showOtpButton: false,
    fetchOtpSuccess: false,
    startCountDownOtp: false,
    loading: false,
    ccNumber: '',
    ccNumberErrorMessage: '',
    ccExpireDate: '',
    ccExpireDateErrorMessage: '',
    ccCVC: '',
    ccCVCErrorMessage: '',
    merchantUid: '',
    transactionId: '',
    bindCardFailed: false,
    loadingCover: false,

    //iknow99
    activatedLicensePlates: [],
    activateLicensePlatesDialog: '',
  };
  const bindCardFormButtonRef = useRef();

  useEffect(() => {
    if (methods.preLogin) {
      methods.preLogin(dispatch);
    }
  }, []); //eslint-disable-line

  const startLoading = state => assign({}, state, { loading: true });
  const hideLoading = state => assign({}, state, { loading: false });
  const fetchOtpSuccess = state => assign({}, state, { fetchOtpSuccess: true, startCountDownOtp: true });
  const otpTimesUp = state => assign({}, state, { startCountDownOtp: false });
  const changeMobile = (state, payload) => assign({}, state, { mobile: payload });
  const changeOtp = (state, payload) => assign({}, state, { otp: payload });
  const changeMobileErrorMessage = (state, payload) => assign({}, state, { mobileErrorMessage: payload });
  const changeOtpErrorMessage = (state, payload) => assign({}, state, { otpErrorMessage: payload });
  const changeEmail = (state, payload) => assign({}, state, { email: payload });
  const changeEmailErrorMessage = (state, payload) => assign({}, state, { emailErrorMessage: payload });
  const setOnStreetParkingAutoPayPassDialog = (state, payload) =>
    assign({}, state, { onStreetParkingAutoPayPassDialog: payload });
  const setRentalPlateDialog = (state, payload) => assign({}, state, { showRentalPlateDialog: payload });
  const changePlateNumber = (state, payload) => assign({}, state, { plateNumber: payload });
  const changePlateNumberErrorMessage = (state, payload) => assign({}, state, { plateNumberErrorMessage: payload });
  const changeCarType = (state, payload) => assign({}, state, { carType: payload });
  const chagenCcNumber = (state, payload) => assign({}, state, { ccNumber: panFormatter(payload) });
  const changeCcExpireDate = (state, payload) => assign({}, state, { ccExpireDate: expireDateFormatter(payload) });
  const changeCcCVC = (state, payload) => assign({}, state, { ccCVC: payload });
  const changeCcNumberErrorMessage = (state, payload) => assign({}, state, { ccNumberErrorMessage: payload });
  const changeCcExpireDateErrorMessage = (state, payload) => assign({}, state, { ccExpireDateErrorMessage: payload });
  const changeCcCVCErrorMessage = (state, payload) => assign({}, state, { ccCVCErrorMessage: payload });
  const appendPaymentData = (state, payload) =>
    assign({}, state, { merchantUid: payload.merchantUid, transactionId: payload.transactionId });
  const bindCardFailed = (state, payload) => assign({}, state, { bindCardFailed: payload });
  const showLoadingCover = (state, payload) => assign({}, state, { loadingCover: payload });
  // iknow99
  const setActivatedLicensePlates = (state, payload) => assign({}, state, { activatedLicensePlates: payload });
  const setActivateLicensePlatesDialog = (state, payload) =>
    assign({}, state, { activateLicensePlatesDialog: payload });

  const reducer = createReducer(
    {
      [START_LOADING]: startLoading,
      [HIDE_LOADING]: hideLoading,
      // login
      [FETCH_OTP_SUCCESS]: fetchOtpSuccess,
      [OTP_TIMES_UP]: otpTimesUp,
      [CHANGE_MOBILE]: changeMobile,
      [CHANGE_MOBILE_ERROR_MESSAGE]: changeMobileErrorMessage,
      [CHANGE_OTP]: changeOtp,
      [CHANGE_OTP_ERROR_MESSAGE]: changeOtpErrorMessage,
      // register
      [CHANGE_EMAIL]: changeEmail,
      [CHANGE_EMAIL_ERROR_MESSAGE]: changeEmailErrorMessage,
      // setup
      [SET_ON_STREET_PARKING_AUTO_PAY_PASS_DIALOG]: setOnStreetParkingAutoPayPassDialog,
      [SET_RENTAL_PLATE_DIALOG]: setRentalPlateDialog,
      [CHANGE_CAR_TYPE]: changeCarType,
      [CHANGE_PLATE_NUMBER]: changePlateNumber,
      [CHANGE_PLATE_NUMBER_ERROR_MESSAGE]: changePlateNumberErrorMessage,
      [CHANGE_CC_NUMBER]: chagenCcNumber,
      [CHANGE_CC_NUMBER_ERROR_MESSAGE]: changeCcNumberErrorMessage,
      [CHANGE_CC_EXPIRE_DATE]: changeCcExpireDate,
      [CHANGE_CC_EXPIRE_DATE_ERROR_MESSAGE]: changeCcExpireDateErrorMessage,
      [CHANGE_CC_CVC]: changeCcCVC,
      [CHANGE_CC_CVC_ERROR_MESSAGE]: changeCcCVCErrorMessage,
      [APPEND_PAYMENT_DATA]: appendPaymentData,
      [BIND_CARD_FAILED]: bindCardFailed,
      [SHOW_LOADING_COVER]: showLoadingCover,
      //iknow99
      [SET_ACTIVATED_LICENSE_PLATES]: setActivatedLicensePlates,
      [SET_ACTIVATE_LICENSE_PLATES_DIALOG]: setActivateLicensePlatesDialog,
    },
    initState,
    true
  );
  const [state, dispatch] = useReducer(reducer, initState);

  const fetchOtp = phone => {
    repo
      .fetchOtp(phone)
      .then(() => {
        dispatch({ type: FETCH_OTP_SUCCESS });
      })
      .catch(error => {
        console.error(error);
      });
  };

  const login = (mobile, otp) => {
    const loginFormCheck = () => {
      const isMobileValid = isPhoneNumber(mobile);
      const mobileErrorMessage = isMobileValid ? '' : '手機號碼格式錯誤';
      const isOtpValid = isOtpCode(otp);
      const otpErrorMessage = isOtpValid ? '' : '驗證格式錯誤';

      dispatch({ type: CHANGE_MOBILE_ERROR_MESSAGE, payload: mobileErrorMessage });
      dispatch({ type: CHANGE_OTP_ERROR_MESSAGE, payload: otpErrorMessage });

      return isMobileValid && isOtpValid;
    };

    if (!loginFormCheck()) return;

    dispatch({ type: START_LOADING });
    repo
      .login(mobile, otp)
      .then(data => {
        if (data.scopes === 'user') {
          const success = payload => {
            appDispatch({
              type: INIT_APP_DONE,
              payload: payload,
            });
            showSuccessMessage('麻吉，歡迎回來');
            dispatch({ type: HIDE_LOADING });

            if (!(isCpcpay || isNpcpay)) {
              connectMQTT({ state: appState, dispatch: appDispatch });
            }
            history.replace(PATH.MAIN);
          };

          const failure = error => {
            showFailMessage(error);
            dispatch({ type: HIDE_LOADING });
          };

          methods.loginAsUser(success, failure);
        } else {
          dispatch({ type: HIDE_LOADING });
          history.replace(PATH.USER_REGISTER);
        }
        dispatch({ type: OTP_TIMES_UP });
      })
      .catch(error => {
        console.log(error);
        dispatch({ type: HIDE_LOADING });
        dispatch({ type: CHANGE_OTP, payload: '' });
        showFailMessage(error);
      });
  };

  const register = email => {
    const registerFormCheck = () => {
      const isEmailValid = isEmail(email);
      const emailErrorMessage = isEmailValid ? '' : '電子郵件格式錯誤';

      dispatch({ type: CHANGE_EMAIL_ERROR_MESSAGE, payload: emailErrorMessage });

      return isEmailValid;
    };

    if (!registerFormCheck()) return;

    dispatch({ type: START_LOADING });

    repo
      .register(email)
      .then(() => {
        const success = payload => {
          appDispatch({
            type: INIT_APP_DONE,
            payload: payload,
          });
          if (!isCpcpay || !isNpcpay) {
            connectMQTT({ state: appState, dispatch: appDispatch });
          }

          if (isNpcpay) {
            history.replace(PATH.USER_ADD_PLATE_NUMBER);
          } else {
            history.replace(PATH.USER_ENABLE_ON_STREET_PARKING_AUTO_PAY);
          }
          showSuccessMessage('歡迎成為麻吉一員');
          dispatch({ type: HIDE_LOADING });
        };

        const failure = error => {
          showFailMessage(error);
          dispatch({ type: HIDE_LOADING });
        };
        methods.loginAsUser(success, failure);
      })
      .catch(error => {
        showFailMessage(error);
        dispatch({ type: HIDE_LOADING });
      });
  };

  const enableOnStreetParkingAutoPay = () => {
    dispatch({ type: START_LOADING });

    repo
      .updateUserInfo(undefined, undefined, undefined, true)
      .then(value => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
        history.replace(isIknow99 ? PATH.USER_BIND_CARD : PATH.USER_ADD_PLATE_NUMBER);
      })
      .catch(error => {
        showFailMessage(error);
      })
      .finally(() => dispatch({ type: HIDE_LOADING }));
  };

  const disableOnStreetParkingAutoPay = () => {
    dispatch({ type: SET_ON_STREET_PARKING_AUTO_PAY_PASS_DIALOG, payload: false });

    repo
      .updateUserInfo(undefined, undefined, undefined, false)
      .then(value => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
        history.replace(isIknow99 ? PATH.USER_ACTIVATE_PLATE_NUMBER : PATH.USER_ADD_PLATE_NUMBER);
      })
      .catch(error => {
        showFailMessage(error);
      });
  };

  const redirectAfterAddPlate = () => {
    const { path } = configData.onBoardingAddPlateNumberData;
    history.replace(path);
  };

  const addPlateNumber = async (plateNumber, carType) => {
    const plateNumberFormCheck = () => {
      const isPlateNumberValid = isPlateNumber(plateNumber);
      const plateNumberErrorMessage = isPlateNumberValid ? '' : '車牌格式錯誤';

      dispatch({ type: CHANGE_PLATE_NUMBER_ERROR_MESSAGE, payload: plateNumberErrorMessage });

      return isPlateNumberValid;
    };

    if (!plateNumberFormCheck()) return;

    dispatch({ type: START_LOADING });

    const { promises } = configData.onBoardingAddPlateNumberData;

    repo
      .addLicensePlate(plateNumber, carType)
      .then(() => {
        Promise.all(promises.map(promise => promise())).then(data => {
          const payload = {
            me: data[0],
            licensePlates: data[1],
            bootstraps: data[2],
          };
          appDispatch({
            type: INIT_APP_DONE,
            payload: payload,
          });

          let plate = data[1].find(d => d.plateNumber === plateNumber);
          if (plate.isRentalCar) {
            dispatch({
              type: SET_RENTAL_PLATE_DIALOG,
              payload: true,
            });
          } else {
            redirectAfterAddPlate();
          }
        });
      })
      .catch(error => {
        showFailMessage(error);
      })
      .finally(() => {
        dispatch({ type: HIDE_LOADING });
      });
  };

  const fetchExistLicensePlates = () => {
    return repo
      .fetchLicensePlates()
      .then(data => {
        appDispatch({
          type: LICENSE_PLATES_IS_SETTED,
        });
        appDispatch({
          type: INIT_APP_DONE,
          payload: {
            licensePlates: data,
          },
        });
      })
      .catch(e => {
        showFailMessage(e);
      });
  };

  const deactivatePlates = async activatedLicensePlates => {
    if (activatedLicensePlates.length === 0) {
      return dispatch({
        type: SET_ACTIVATE_LICENSE_PLATES_DIALOG,
        payload: true,
      });
    }

    const deletePlates = appState.licensePlates.filter(
      plate => activatedLicensePlates.indexOf(plate.plateNumber) === -1
    );

    return Promise.all([
      ...deletePlates.map(plate => {
        return repo.deleteLicensePlate(plate.id);
      }),
      repo.agreeTermsOfTaipeiParkinglotService,
    ])
      .then(() => {
        return repo
          .fetchLicensePlates()
          .then(data => {
            appDispatch({
              type: INIT_APP_DONE,
              payload: {
                licensePlates: data,
              },
            });
          })
          .catch(e => {
            showFailMessage(e);
          });
      })
      .then(() => {
        history.push(PATH.USER_BIND_CARD);
      });
  };

  const bindCpcPayCard = () => {
    amplitude.bindCard_button_onClick({ paymentType: 'bind' });
    dispatch({ type: START_LOADING });
    repo
      .bindCpcPay(getCpcId())
      .then(() => repo.fetchUserInfo())
      .then(value => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
        showSuccessMessage('連結成功');
        if (appState.me?.enableOnStreetParkingAutoPay) {
          history.replace(PATH.USER_ON_STREET_PARKING_AUTO_PAY_NOTICE);
        } else {
          history.replace(PATH.MAIN);
        }
      })
      .catch(error => {
        showFailMessage(error);
        dispatch({
          type: BIND_CARD_FAILED,
          payload: true,
        });
      })
      .finally(() => {
        dispatch({ type: HIDE_LOADING });
      });
  };

  const bindCard = () => {
    const bindCardFromCheck = () => {
      const isCcNumber = isCreditCardPan(state.ccNumber);
      const isCcExpireDate = isCreditCardExpireDate(state.ccExpireDate);
      const isCcCVC = isCreditCardCVC(state.ccCVC);

      const ccNumberErrorMessage = isCcNumber ? '' : '格式錯誤';
      const ccExpireDateErrorMessage = isCcExpireDate ? '' : '格式錯誤';
      const ccCVCErrorMessage = isCcCVC ? '' : '格式錯誤';

      dispatch({ type: CHANGE_CC_NUMBER_ERROR_MESSAGE, payload: ccNumberErrorMessage });
      dispatch({ type: CHANGE_CC_EXPIRE_DATE_ERROR_MESSAGE, payload: ccExpireDateErrorMessage });
      dispatch({ type: CHANGE_CC_CVC_ERROR_MESSAGE, payload: ccCVCErrorMessage });

      return isCcNumber && isCcExpireDate && isCcCVC;
    };

    if (!bindCardFromCheck()) return;

    amplitude.bindCard_button_onClick({ paymentType: state.ccNumber });
    dispatch({ type: START_LOADING });

    repo
      .initMochipayValidation()
      .then(value => {
        dispatch({ type: APPEND_PAYMENT_DATA, payload: value });
        if (bindCardFormButtonRef.current !== null) {
          bindCardFormButtonRef.current.click();
        }
      })
      .catch(error => {
        showFailMessage(error);
      });
  };

  const bindCardSuccess = (token, transactionId, callback) => {
    dispatch({ type: START_LOADING });

    repo
      .bindMochipayWallet(token, transactionId)
      .then(() => repo.fetchUserInfo())
      .then(value => {
        appDispatch({
          type: BINDING_IS_SETTED,
        });
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
        dispatch({
          type: HIDE_LOADING,
        });
        history.replace(PATH.USER_ON_STREET_PARKING_AUTO_PAY_NOTICE);
        callback();
        showSuccessMessage('綁定成功');
      })
      .catch(error => {
        callback();
        dispatch({
          type: HIDE_LOADING,
        });
        showFailMessage(error);
      });
  };

  const bindCardFail = (message, callback) => {
    callback();
    showFailMessage(message);
  };

  return {
    state,
    dispatch,
    fetchOtp,
    login,
    register,
    enableOnStreetParkingAutoPay,
    disableOnStreetParkingAutoPay,
    addPlateNumber,
    bindCpcPayCard,
    bindCard,
    bindCardSuccess,
    bindCardFail,
    bindCardFormButtonRef,
    fetchExistLicensePlates,
    deactivatePlates,
    redirectAfterAddPlate,
  };
};

const [LoginFlowProvider, useLoginFlowContext] = constate(useLoginFlow);

export { LoginFlowProvider, useLoginFlowContext };
